//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    data(){
        return{
            type: this.$route.query.type,
            list: {}
        }
    },
    created(){
        this.query();
    },
    methods: {
        query(){
            var data = {
                patientid: this.$route.query.patientid == null || this.$route.query.patientid == '' ? sessionStorage.patientid : this.$route.query.patientid,
                hospitainid: this.$store.state.clinicId == null || this.$store.state.clinicId == '' ? (sessionStorage.hospitainid == null || sessionStorage.hospitainid == '' ? this.$route.query.hospitainid : sessionStorage.hospitainid) : this.$store.state.clinicId,
                doctorid: this.$store.state.doctorId == null || this.$store.state.doctorId == '' ? (sessionStorage.doctorid == null || sessionStorage.doctorid == '' ? this.$route.query.doctorid : sessionStorage.doctorid) : this.$store.state.doctorId
            }
            if(this.$store.state.userInfo.sessionId == null || this.$store.state.userInfo.sessionId == ''){
                this.$store.state.userInfo.sessionId = 'haozhongyi';
            }
            this.$doRequest('/api/diagnosisqueue/find', data, res=>{
                this.list = res.parameters;
            })
        }
    }
}



// WEBPACK FOOTER //
// ./src/views/systemRegistered/payResult/index.vue